module.exports = __webpack_public_path__ + "img/cuff_length.90c4af40.png";